import { CloudUpload } from 'lucide-react'

import { cn } from '../../utils/cn'

/**
 * The outline a panel shows while files are dragged over it. Absolutely
 * positioned, so the drop zone it fills has to be a positioned ancestor.
 */
export function FileDropOverlay({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      data-slot="file-drop-overlay"
      className={cn(
        'border-brand-600/60 bg-brand-100/40 pointer-events-none absolute inset-2 z-20 flex items-center justify-center rounded-lg border-2 border-dashed',
        className
      )}
    >
      <CloudUpload strokeWidth={1.25} className="text-brand-800/40 size-20" />
    </div>
  )
}
